import { combineReducers } from 'redux';
import quizReducer from './quiz-reducer';
import adminReducer from './admin-reducer';

export default combineReducers({
  quiz: quizReducer,
  admin: adminReducer,
});
